import React from 'react';
import { Link } from 'react-router-dom';

interface FooterProps {
  darkMode: boolean;
  showAd?: boolean;
}

const Footer: React.FC<FooterProps> = ({ darkMode, showAd = false }) => {
  const theme = {
    text: darkMode ? 'text-gray-500' : 'text-gray-400',
    link: darkMode ? 'text-gray-400 hover:text-gray-300' : 'text-gray-500 hover:text-gray-700',
  };

  return (
    <footer className="flex-shrink-0 pt-8 pb-4 flex flex-col items-center gap-4 mt-12">
      {showAd && (
        <div className="w-full mb-4">
          {/* Ad space - can be added here if needed */}
        </div>
      )}
      <div className={`text-sm flex flex-col items-center gap-4 ${theme.text}`}>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <a href="https://echologai.com/" target="_blank" rel="noopener noreferrer" className={`hover:underline font-medium ${theme.link}`}>
            Echolog AI
          </a>
          <span className="hidden sm:inline">•</span>
          <Link to="/about" className={`hover:underline ${theme.link}`}>About</Link>
          <span className="hidden sm:inline">•</span>
          <a href="https://echologai.com/blog/" target="_blank" rel="noopener noreferrer" className={`hover:underline ${theme.link}`}>
            Blog
          </a>
          <span className="hidden sm:inline">•</span>
          <Link to="/privacy" className={`hover:underline ${theme.link}`}>Privacy Policy</Link>
          <span className="hidden sm:inline">•</span>
          <Link to="/terms" className={`hover:underline ${theme.link}`}>Terms of Service</Link>
          <span className="hidden sm:inline">•</span>
          <a href="mailto:echolog07@gmail.com" className={`hover:underline ${theme.link}`}>Contact</a>
        </div>
        <span className="text-xs">© 2025 Echolog AI Team. All rights reserved.</span>
      </div>
    </footer>
  );
};

export default Footer;

